<template>
    <div
      :id="`tab-${id}`"
      v-show="isActive"
      :aria-hidden="!isActive"
      class="tabs-component-panel"
      role="tabpanel"
    >
      <h2 v-if="title && showTitle">{{ title }}</h2>
      <slot />
    </div>
</template>

<script setup lang="ts">
  import { computed, inject, ref, watch, type Component } from 'vue';
  import type { Tab } from '@/types/Tab';

  const props = withDefaults(defineProps<{
    id: string;
    title?: string;
    showTitle?: boolean;
    icon?: Component | null;
  }>(),
  {
    showTitle: false,
  });

  const activeTab = inject("activeTab", ref(''));

  const isActive = computed(() => {
    return activeTab.value === props.id;
  });

  const tabProps = computed(() => {
    return {
      id: props.id,
      title: props.title,
      showTitle: props.showTitle,
      isActive: isActive.value,
      icon: props.icon,
    }
  })

  const registerTab = inject<(tab: Tab) => void>("registerTab");

  watch(tabProps, (newVal) => {
    if (registerTab) {
      registerTab(newVal)
    }
  }, { immediate: true, deep: true})
</script>